import templateUrl from "emun.invoice/inv/inv-list-grid.htm";
export default () => ({ templateUrl });
